import React, { Component } from 'react';
import '../../Home/Home.css';

import { Link } from 'react-router-dom';

import icon8 from '../../../image/icon8.png'
import icon9 from '../../../image/icon9.svg'
class Footer extends Component {

    render() {

        return (
            <div className="home pt-5">
              <footer className="  p-lg-5 py-4 px-2">
                    <div className="container ">
                        <div className="row mx-0">
                            <div className="col-md-3">
                                <ul>
                                    <p className="font-weight-bold">JOIN US</p>
                                    <li className=" text-muted "><Link to="/SignUp">Sign Up</Link></li>
                                    <li className=" text-muted "><Link to="/Courier/SignUp">Couriers</Link></li>
                                </ul>
                            </div>
                            <div className="col-md-3">
                                <ul>
                                    <p className="font-weight-bold">HELP</p>
                                    <li className=" text-muted "><Link to="/FAQS">FAQS</Link></li>
                                    <li className=" text-muted "><Link to="/ContactUs">Contact us</Link></li>

                                </ul>
                            </div>

                            <div className="col-md-3">

                                <ul>
                                    <p className="font-weight-bold">LEGAL</p>
                                    <li className=" text-muted "><Link to="/Policy">Privacy Policy</Link></li>
                                    <li className=" text-muted "><Link to="/termsconditions">Terms  Conditions </Link></li>

                                </ul>
                            </div>

                            <div className="col-md-3">
                                <ul>
                                    <p className="font-weight-bold">FOLLOW US</p>
                                    <a href="https://www.facebook.com/Kayn-219444555581932/" target="_blank"><img className="m-3" src={icon9} alt="https://www.facebook.com/Kayn-219444555581932/" /></a>
                                    <a href="https://www.instagram.com/getkayn/" target="_blank"><img className="m-3 icon8" src={icon8} alt="https://www.instagram.com/getkayn/" /></a>
                                </ul>
                            </div>
                        </div>
                </div>
                
                <div className="col-md-4 mx-auto text-center">

                </div>
            </footer>
            </div>

        )
    }
}
export default Footer;